import {
  CardWrapper,
  ContentWrapper,
  Description,
  DeviceImage,
  ImageWrapper,
  Title,
} from './styles.ts';
import TagItem from '@atomaro/ui-kit/components/Tag/TagItem/TagItem';
import {Button} from '@atomaro/ui-kit';
import {DeviceCardData} from 'widgets/devicesInfo/consts/cards.consts.ts';

interface DeviceCardProps {
  card: DeviceCardData;
  handleOpenModal: (card: DeviceCardData) => void;
  img: string;
}

export const DeviceCard = (props: DeviceCardProps) => {
  const {card, handleOpenModal, img} = props;

  return (
    <CardWrapper>
      <ImageWrapper>
        <DeviceImage src={img} alt="Устройство 2" />
      </ImageWrapper>

      <ContentWrapper>
        <div>
          <TagItem size={'s'}>{card.vendorName}</TagItem>
        </div>

        <Title>{card.name}</Title>

        <Description>{card.description}</Description>

        <div>
          <Button label={'Подробнее'} onClick={() => handleOpenModal(card)} />
        </div>
      </ContentWrapper>
    </CardWrapper>
  );
};
